"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _FoodMenu = require("../../../FoodMenu.context");

var _modifiers = require("../modifiers");

var _menu = _interopRequireDefault(require("../../../utils/menu"));

var _ItemVariations = _interopRequireDefault(require("./ItemVariations"));

var ItemBasic = function ItemBasic(_ref) {
  var id = _ref.id,
      name = _ref.name,
      description = _ref.description,
      variations = _ref.variations,
      onClick = _ref.onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_react["default"].createElement(_FoodMenu.MenuConsumer, null, function (_ref2) {
    var items = _ref2.items,
        modifierSets = _ref2.modifierSets,
        disableModifiers = _ref2.disableModifiers;

    var item = _menu["default"].getItemById(items, id);

    var itemModifierSetIds = item.modifier_sets;

    var itemModifierSets = _menu["default"].getItemModifierSets(itemModifierSetIds, modifierSets);

    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.List.Item, {
      style: {
        paddingBottom: '1rem'
      },
      onClick: onClick,
      className: className
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexWrap: 'wrap'
      }
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
      as: "h5"
    }, name), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Divider, {
      style: {
        flexGrow: 1,
        margin: '1rem 0.5rem 0 0.5rem'
      }
    }), /*#__PURE__*/_react["default"].createElement(_ItemVariations["default"], {
      variations: variations
    })), /*#__PURE__*/_react["default"].createElement("p", {
      style: {
        marginBottom: '0.25rem'
      }
    }, description), !disableModifiers && /*#__PURE__*/_react["default"].createElement(_modifiers.ModifierSetsBasic, {
      modifierSets: itemModifierSets
    }));
  });
};

var _default = ItemBasic;
exports["default"] = _default;